import { resolveDeviceFingerprintLogic } from './resolveDeviceFingerprintLogic';

export const logic = [resolveDeviceFingerprintLogic];
